import validate from "/usr/src/app/content/n3-treatments-450e3fd7-d575-458d-b82d-b8c302cfb9cd/b2c-build/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/usr/src/app/content/n3-treatments-450e3fd7-d575-458d-b82d-b8c302cfb9cd/b2c-build/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {}